import React, { useContext, useMemo, useState } from 'react';
import ForgeDialogWrapper from '../../reusable/ForgeDialogWrapper/ForgeDialogWrapper.js';
import { APPLY, CANCEL } from '../../../static/keyWords.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import PropTypes from 'prop-types';
import BoundaryRow from './boundaryRow.js';
import { INITIAL_FILTERS_STATE, INITIAL_MATCH_SETTINGS_STATE } from '../costBenchmarkHelpers.js';
import { THRESHOLD } from '../costBenchmarkTexts.js';
import { CostBenchmarkContext } from '../../../contexts/costBenchmarkingContext.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';

const BoundariesModal = ({ open, onClose, onSubmit }) => {
  const { matchSettings, populationBoundaries, setMatchSettings, defaultFilters, setDefaultFilters } = useContext(CostBenchmarkContext);
  const [filters, setFilters] = useState(defaultFilters);
  const { nameConventions } = useNameConventions();
  const [settings, setSettings] = useState(matchSettings);
  const isValid = useMemo(() => {
    const filtersChanged = JSON.stringify(filters) !== JSON.stringify(INITIAL_FILTERS_STATE);
    const settingsChanged = JSON.stringify(settings) !== JSON.stringify(INITIAL_MATCH_SETTINGS_STATE);

    return filtersChanged || settingsChanged;
  }, [filters, settings]);

  const onChangeFilters = (event) => {
    const { valueStart, valueEnd } = event.detail;
    setFilters({ populationMin: valueStart, populationMax: valueEnd });
  };

  const onChangeMatchSettings = (event) => {
    const { value } = event.detail;
    setSettings((previousSettings) => ({
      ...previousSettings,
      [THRESHOLD]: value,
    }));
  };

  const handleSubmit = () => {
    setMatchSettings(settings);
    setDefaultFilters(filters);
    onSubmit({ filters, matchSettings: settings });
    onClose();
  };

  return (
    <ForgeDialogWrapper
      open={open}
      title={messageManager(nameConventions).COST_BENCHMARK.BOUNDARIES_MODAL_TITLE}
      showPrimaryButton
      primaryButtonText={APPLY}
      showSecondaryButton
      secondaryButtonText={CANCEL}
      handleClickPrimaryButton={() => handleSubmit()}
      handleClickSecondaryButton={() => onClose()}
      handleClose={() => onClose()}
      primaryButtonDisabled={!isValid}
    >
      <BoundaryRow step={1} range min={populationBoundaries?.min} max={populationBoundaries?.max} startValue={filters.populationMin} endValue={filters.populationMax} disabled={false} label={'Reference Population Range:'} onForgeSliderRangeChange={onChangeFilters} />
      <div className="marginBottom marginTop forge-typography--body1 bold">Match Quality Controls</div>
      <BoundaryRow name={THRESHOLD} min={0} max={1} value={settings.threshold} disabled={false} label={'Match Threshold:'} onChange={onChangeMatchSettings} />
    </ForgeDialogWrapper>
  );
};

BoundariesModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default BoundariesModal;
